export const getBase64FromUrl = async url => {
  const data = await fetch(url, { cache: 'force-cache' });
  const blob = await data.blob();
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};

export const getLogo64Object = async url => {
  const data = await getBase64FromUrl(url);
  return { url: url, base64: data };
};
